// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FolderFilledSvg from "@fishx/icons-svg/es/asn/FolderFilled";
import FishxIcon from '../components/FishxIcon';

var FolderFilled = function FolderFilled(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FolderFilledSvg
  }));
};

FolderFilled.displayName = 'FolderFilled';
export default React.forwardRef(FolderFilled);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FolderFilled.js
// module id = 2804
// module chunks = 0